var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.352,378.533h-17.7a1.149,1.149,0,0,1-1.148-1.148V361.648a1.149,1.149,0,0,1,1.148-1.148h17.7a1.149,1.149,0,0,1,1.148,1.148v15.738A1.149,1.149,0,0,1,168.352,378.533Zm-17.7-17.049a.166.166,0,0,0-.164.164v15.738a.166.166,0,0,0,.164.164h17.7a.166.166,0,0,0,.164-.164V361.648a.166.166,0,0,0-.164-.164Z",
    transform: "translate(-149.5 -360.5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.992,358.762a.492.492,0,0,1-.492-.492v-3.279a.492.492,0,1,1,.984,0v3.279A.492.492,0,0,1,168.992,358.762Z",
    transform: "translate(-168.5 -354.5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.992,358.762a.492.492,0,0,1-.492-.492v-3.279a.492.492,0,1,1,.984,0v3.279A.492.492,0,0,1,188.992,358.762Z",
    transform: "translate(-188.5 -354.5)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.934 7.541)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H163.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,163.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-161.5 -377.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.918 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H178.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,178.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-176.5 -377.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.836 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.3,379.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H193.3a.492.492,0,0,1,.492.492V379.3A.492.492,0,0,1,193.3,379.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-191.5 -377.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H163.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,163.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-161.5 -392.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.918 4.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H178.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,178.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-176.5 -392.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.836 4.918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.3,394.8h-1.311a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,0,1,.492-.492H193.3a.492.492,0,0,1,.492.492V394.3A.492.492,0,0,1,193.3,394.8Zm-.82-.984h.328v-.328h-.328Z",
    transform: "translate(-191.5 -392.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.2838e0f9a65ca914b4bd19958c23c3e0.svg";
export { ForwardRef as ReactComponent };